// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-main_layout__3ud5-","sidebar":"layout-main_sidebar__2rsDz","popup_title":"layout-main_popup_title__LkaNK","video":"layout-main_video__2QtIb"};